import axios from "../utils/axios";

export const getRootCauseFamilyAndOptions = () => {
    return axios.get(`/EwoForm/GetRootCausesFamilyAndOptions`);
};